import {
  FETCH_WORKER_PAYOUT_MASTERDATA,
  FETCH_WORKER_PAYOUT_MASTERDATA_LOADING,
  FETCH_WORKER_INVOICE_MASTERDATA,
  FETCH_WORKER_INVOICE_MASTERDATA_LOADING,
  FETCH_WORKER_MASTERDATA_ERROR,
  INVALIDATE_WORKER_MASTERDATA,
} from '../actions/constants';

const defaultState = {
  payoutData: null,
  payoutLoading: false,
  invoiceData: null,
  invoiceLoading: false,
  error: null,
};

export default function workerPayoutsMasterDataReducer(
  state = defaultState,
  action,
) {
  switch (action.type) {
    case FETCH_WORKER_PAYOUT_MASTERDATA_LOADING:
      return {
        ...state,
        payoutLoading: true,
      };

    case FETCH_WORKER_PAYOUT_MASTERDATA:
      return {
        ...state,
        payoutLoading: false,
        payoutData: { ...action.data, isFetched: true },
      };

    case FETCH_WORKER_INVOICE_MASTERDATA_LOADING:
      return {
        ...state,
        invoiceLoading: true,
      };

    case FETCH_WORKER_INVOICE_MASTERDATA:
      return {
        ...state,
        invoiceLoading: false,
        invoiceData: { ...action.data, isFetched: true },
      };

    case FETCH_WORKER_MASTERDATA_ERROR:
      return {
        ...state,
        payoutLoading: false,
        invoiceLoading: false,
        error: action.error,
      };

    case INVALIDATE_WORKER_MASTERDATA:
      return {
        ...defaultState,
      };

    default:
      return state;
  }
}
